import {
  type ListUserProfilesPageRequest,
  type UserProfileOut,
  listUserProfilesPagePassportIdmIdmListUserProfilesPagePost,
} from '@/shared/api/intranet'

export const listUserProfilesPage = async ({
  page = {
    number: 1,
    size: 1,
  },
  filter = { query: '', ids: [] },
  signal = undefined,
}: ListUserProfilesPageRequest & { signal?: AbortSignal | null | undefined }): Promise<{
  totalPages: number
  userProfiles: UserProfileOut[]
}> => {
  const { data } = await listUserProfilesPagePassportIdmIdmListUserProfilesPagePost({
    body: {
      page,
      filter,
    },
    signal,
    throwOnError: true,
  })

  return { userProfiles: data.userProfiles, totalPages: data.pagination.totalPages }
}
